module.exports = __webpack_public_path__ + "img/arrow_down_2.b814ce15.svg";